'use client';

import { Modal } from '#/components/ui/modal';
import { Button } from '#/components/ui/button';
import { useAlertModal } from '#/hooks/use-alert-modal';
import { Icons } from '../icons';
import { useMounted } from '#/hooks';
import { useT } from '#/i18n/client';

export const AlertModal = () => {
  const t = useT('common');
  const {
    title,
    description,
    contents,
    type,
    isOpen,
    onConfirm,
    close,
    loading,
    isDelete,
    width
  } = useAlertModal();
  const mounted = useMounted();

  if (!mounted) {
    return null;
  }
  console.log(width);
  return (
    <Modal
      title={title}
      description={description}
      isOpen={isOpen}
      onClose={close}
      className={`gap-4 max-h-[70vh] sm:max-h-[80vh] overflow-y-auto   ${width} `}
      classNames={{
        header: 'space-y-2'
      }}
    >
      {contents}
      <div className="space-x-2 flex items-center justify-end w-full">
        {type === 'error' ||
          (type === 'confirm' && (
            <Button disabled={loading} variant="outline" onClick={close}>
              {t('alertModal.cancel')}
            </Button>
          ))}
        <Button
          disabled={loading}
          variant={type === 'error' ? 'destructive' : 'default'}
          onClick={onConfirm}
        >
          {loading && <Icons.spinner className="btn-spinner-with-text" />}
          {isDelete ? t('alertModal.delete') : t('alertModal.ok')}
        </Button>
      </div>
    </Modal>
  );
};
